import OperationalReportPage from './OperationalReportPage';
export default function CounterShiftReportPage(){return <OperationalReportPage kind="counter-shift"/>;}
